
import { Profile } from "@/types/profile";
import { ExternalLink } from "lucide-react";

interface ProfileFooterProps {
  profile: Profile;
}

export const ProfileFooter = ({ profile }: ProfileFooterProps) => {
  if (!profile.show_powered_by) {
    return null;
  }
  
  return (
    <footer className="mt-auto py-6 border-t border-border/30">
      <div className="container mx-auto px-4 text-center text-sm text-muted-foreground flex items-center justify-center space-x-1">
        <span>Powered by</span>
        <a 
          href="https://showee.com" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="text-primary hover:underline flex items-center"
        >
          Showee.com
          <ExternalLink className="h-3 w-3 ml-1" />
        </a>
      </div>
    </footer>
  );
};
